import { appWithTranslation as appWithTranslation$1, useTranslation as useTranslation$1 } from 'next-i18next';
export { Trans } from 'next-i18next';
import './i18n.config.js';
export { ABSOLUTE_LOCALES, ALL_LOCALES, COUNTRY_LANGUAGES, DEFAULT_LOCALE, LOCALE_FORMAT, SUPPORTED_COUNTRIES, formatLocale } from './i18n.constants.js';

/**
 * Hook for using translations in components
 * @param ns - namespace or array of namespaces
 * @param options - additional options for translation
 * @returns translation utilities
 */ const useTranslation = (ns, options)=>{
    return useTranslation$1(ns, options);
};
/**
 * Helper function to get translation without hooks
 * @param key - translation key
 * @param ns - namespace
 * @param defaultValue - fallback value if translation is not found
 * @returns translated string
 */ const t = (key, ns, defaultValue)=>{
    try {
        const { t: translate } = useTranslation$1(ns);
        return translate(key, {
            defaultValue
        });
    } catch (error) {
        console.warn(`Translation failed for key: ${key}`, error);
        return defaultValue || key;
    }
};
/**
 * HOC for wrapping Next.js app with i18next provider
 * @param Component - Next.js App component
 * @returns Wrapped component with i18next provider
 */ const appWithTranslation = appWithTranslation$1;

export { appWithTranslation, t, useTranslation };
//# sourceMappingURL=index.js.map
